import { useAtom } from 'jotai'

import { userAtom } from '../../state/auth'
import SignalsPage from '../../components/signals/SignalsPage'

// MWA-421 — the client's Signals page. The data and the Action write are in
// SignalsPage; this only says who is looking.
export default function PortalSignals() {
  const [user] = useAtom(userAtom)
  // ProtectedPortalRoute does not render the portal until user.clientId is set.
  return <SignalsPage clientId={user?.clientId || ''} clientName={user?.name || ''} audience="client" />
}
